
























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { debounce } from 'lodash'
import { Getter, Action } from 'vuex-class'
import download from 'downloadjs'

// Helpers
import { downloadFile } from '@/helpers/download'
import { parseBase64Stream } from '@/helpers/image'

// Components
import ImageViewerValue from '@/components/common/ImageViewerValue.vue'
import ImageCanvasAnnotations from '@/components/common/ImageCanvasAnnotations.vue'

// Views
import PhotoMap from '@/views/report/parts/PhotoMap.vue'

@Component({
  components: { ImageViewerValue, ImageCanvasAnnotations, PhotoMap }
})
export default class Gallery extends Vue {
  // currentSlide: number = 1
  reduced: boolean = true
  $refs: any

  // Current Section is String because of 'photo-scan'
  currentSectionID: string = null
  currentSlideID: number = null

  @Prop() datas: any
  @Prop({ default: null }) activeID: number
  @Prop() state: string
  @Prop() dropoff: boolean

  @Getter('token') token
  @Getter('gallery', { namespace: 'report' }) gallery
  @Action('updateGallery', { namespace: 'report' }) updateGallery

  keyPressed = debounce((e) => {
    if (e.code === 'ArrowLeft' || e.key === 'ArrowLeft' || e.keyCode === 37) {
      this.goToPrev()
    }

    if (e.code === 'ArrowRight' || e.key === 'ArrowRight' || e.keyCode === 39) {
      this.goToNext()
    }

    if (e.code === 'Space' || e.key === 'Space' || e.keyCode === 32 ) {
      this.reduced = !this.reduced
    }

  }, 200, { 'leading': true, 'trailing': false }) // tslint:disable-line

  get canGoPrev(): boolean {
    return this.currentSlideIndex !== 0
  }

  get canGoNext(): boolean {
    return this.currentSlideIndex < this.currentSection.photos.length - 1
  }

  get isDoubleThumb(): boolean {
    return this.dropoff && (this.state === 'finished' || this.state === 'pending_second')
  }

  get currentSection() {
    return this.datas.find((section) => section.id.toString() === this.currentSectionID)
  }

  get currentSlideIndex() {
    return this.currentSection.photos.findIndex((photo) => photo.id === this.currentSlideID)
  }

  get currentSlide() {
    return this.currentSection.photos.find((photo) => photo.id === this.currentSlideID)
  }

  created() {
    document.addEventListener('keydown', this.keyPressed)
    this.currentSectionID = this.gallery.partID
    this.currentSlideID = this.gallery.photoID
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.keyPressed)
  }

  goToNext() {
    if (!this.canGoNext) {
      return
    }
    this.currentSlideID = this.currentSection.photos[this.currentSlideIndex + 1].id
    // this.$refs.thumbs.scrollLeft += 150
  }

  goToPrev() {
    if (!this.canGoPrev) {
      return
    }
    this.currentSlideID = this.currentSection.photos[this.currentSlideIndex - 1].id
    // this.$refs.thumbs.scrollLeft -= 150
  }

  goToSection(id) {
    this.currentSectionID = id.toString()
    this.currentSlideID = this.currentSection.photos[0].id
  }

  goToSlide(id) {
    this.currentSlideID = id
  }

  async downloadPhoto(path, id) {
    let extension = null
    const res = await this.$api.image.getImageFromHash(this.token, path, false)
    const data = res.data.data

    if (data.indexOf('/9j') !== -1) {
      extension = 'jpg'
    }

    if (data.indexOf('iVBOR') !== -1) {
      extension = 'png'
    }

    if (!extension) {
      return
    }

    download(`data:image/${extension};base64,${data}`, `photo-report-${id}.${extension}`, `image/${extension}`)
  }
}
